// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__XeXgs","content":"LoadingAlert_content__3gjco"};